import { createDeferredData, DeferredData } from '../../../infrastructure/adapters/DeferredDataAdapter';
import { 
  useAdminStats, 
  selectTotalLeads, 
  selectLeadsToday, 
  selectLeadsThisWeek, 
  selectActiveEmployees, 
  selectJobsToday, 
  selectConverted 
} from '../hooks/useAdminStats';
import { KPIWidgetData } from '../../shared/kpi/SharedKPIWidget';

type KPIQueryAdapterResult = {
  data?: DeferredData<KPIWidgetData>;
  isLoading: boolean;
  isError: boolean;
  error?: Error | null;
  refetch: () => void;
};

export function useAdminTotalLeadsAdapter(): KPIQueryAdapterResult {
  const query = useAdminStats(selectTotalLeads);
  const data = query.data !== undefined 
    ? createDeferredData<KPIWidgetData>({ primaryValue: query.data }) 
    : undefined;
  
  return { ...query, data, refetch: query.refetch as () => void };
}

export function useAdminLeadsTodayAdapter(): KPIQueryAdapterResult {
  const query = useAdminStats(selectLeadsToday);
  const data = query.data !== undefined 
    ? createDeferredData<KPIWidgetData>({ primaryValue: query.data }) 
    : undefined;
  
  return { ...query, data, refetch: query.refetch as () => void };
}

export function useAdminLeadsThisWeekAdapter(): KPIQueryAdapterResult {
  const query = useAdminStats(selectLeadsThisWeek);
  const data = query.data !== undefined 
    ? createDeferredData<KPIWidgetData>({ primaryValue: query.data }) 
    : undefined;
  
  return { ...query, data, refetch: query.refetch as () => void };
}

export function useAdminActiveEmployeesAdapter(): KPIQueryAdapterResult {
  const query = useAdminStats(selectActiveEmployees);
  const data = query.data !== undefined 
    ? createDeferredData<KPIWidgetData>({ primaryValue: query.data }) 
    : undefined;
  
  return { ...query, data, refetch: query.refetch as () => void };
}

export function useAdminScansTodayAdapter(): KPIQueryAdapterResult {
  const query = useAdminStats(selectJobsToday);
  const data = query.data !== undefined 
    ? createDeferredData<KPIWidgetData>({ primaryValue: query.data }) 
    : undefined;
  
  return { ...query, data, refetch: query.refetch as () => void };
}

export function useAdminConvertedAdapter(): KPIQueryAdapterResult {
  const query = useAdminStats(selectConverted);
  const data = query.data !== undefined 
    ? createDeferredData<KPIWidgetData>({ primaryValue: query.data }) 
    : undefined;
  
  return { ...query, data, refetch: query.refetch as () => void };
}
